import { cn } from '@lib/cn'

export function getBaseInputStyles(hasError: boolean) {
  return cn(
    'relative block h-10 w-full border-b border-rolexBrown/20 bg-transparent pb-2 pt-4 outline-none',
    'focus:border-rolexBrown',
    'disabled:text-shade-900 placeholder:text-rolexBrown placeholder:text-[10px] placeholder:font-bold placeholder:opacity-50 placeholder:leading-[2.5] placeholder:lg:text-[14px] disabled:cursor-not-allowed',
    'text-[18px] leading-[1.6] lg:text-[20px]',
    hasError
      ? 'border-b-2 border-rolexRed text-rolexRed hover:border-shade-500'
      : 'border-shade-500',
  )
}
